// extracted by mini-css-extract-plugin
export default {"customCheckBox":"CustomCheckbox_customCheckBox__I9qzF"};